import { Fragment } from "react";

import { PatientInsurance } from "pwapi";

import { CaseDetailPatient } from "shared/reducers/caseDetailReducer";

type InsurersProps = {
  patient: CaseDetailPatient;
};

const Insurers = ({ patient }: InsurersProps) => {
  let primaries: PatientInsurance[] = [];
  let secondaries: PatientInsurance[] = [];
  if (patient && patient.insurance) {
    primaries = patient.insurance.filter((policy) => policy.primary_provider);
    secondaries = patient.insurance.filter(
      (policy) => !policy.primary_provider
    );
  }
  return primaries.length + secondaries.length > 0 ? (
    <>
      <dt>Insurance</dt>
      <dd>
        <p>
          {primaries.map((policy: PatientInsurance, index) => (
            <Fragment key={`Primary_${index}`}>
              <>
                <strong>Primary:</strong>&nbsp;{policy.insurance_company_name}
                &nbsp;({policy.policy_number})
              </>
              {index < primaries.length - 1 || secondaries.length > 0 ? (
                <br />
              ) : (
                ""
              )}
            </Fragment>
          ))}
          {secondaries.map((policy: PatientInsurance, index) => (
            <Fragment key={`Secondary_${index}`}>
              <>
                <strong>Secondary:</strong>&nbsp;{policy.insurance_company_name}
                &nbsp;({policy.policy_number})
              </>
              {index < secondaries.length - 1 ? <br /> : ""}
            </Fragment>
          ))}
        </p>
      </dd>
    </>
  ) : null;
};

export default Insurers;
